const handleByCampaign: {[key: string]: string} = {
    "1BpQZKdfJM5k64x9UySGPD": "Alexa_Flexy"
};

export default handleByCampaign;
